import "../error/error.scss"
export const ErrorPage = () => {
    return (
        <div className="error-page">
            <h2>😕</h2>
            <h1>Page not found!</h1>
            <p>We can not find the page you are looking for , Sorry about that.</p>
        </div>
    )
} 